import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAdminData, useActiveServices } from "../../../store/adminDataStore";

export default function ServicePreviewSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language?.split("-")[0] ?? "en") as "zh" | "en" | "ja";
  const services = useActiveServices();

  if (services.length === 0) return null;

  return (
    <section className="bg-[#2C2C2C] py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.4em] text-[#C8B8A6] mb-4">Services</p>
          <h2 className="text-4xl lg:text-5xl font-extralight text-white mb-4" style={{ letterSpacing: "-0.02em" }}>
            {t("tabifoto.services.section_title")}
          </h2>
          <p className="text-sm text-white/30 font-light tracking-wide">
            {t("tabifoto.services.section_sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {services.map((service) => (
            <div key={service.id}
              className="group bg-[#F7F6F3]/5 hover:bg-[#F7F6F3]/10 border border-white/10 rounded-lg overflow-hidden transition-all duration-300"
            >
              <div className="relative overflow-hidden" style={{ height: "260px" }}>
                <img
                  src={service.cover_image_url}
                  alt={service[`title_${lang}`]}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105 opacity-70 group-hover:opacity-80"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C]/80 to-transparent" />
              </div>

              <div className="p-8">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#C8B8A6]/40 text-[#C8B8A6] shrink-0 mt-0.5">
                    <i className={`${service.icon} text-lg`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-light text-white mb-2 leading-snug">
                      {service[`title_${lang}`]}
                    </h3>
                    <p className="text-sm text-white/40 font-light leading-relaxed">
                      {service[`short_desc_${lang}`]}
                    </p>
                  </div>
                </div>

                <ul className="space-y-2 mb-6 pl-14">
                  {service.features.map((feat, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-white/50">
                      <div className="w-3 h-3 flex items-center justify-center shrink-0">
                        <i className="ri-check-line text-[#C8B8A6] text-xs" />
                      </div>
                      {feat[lang]}
                    </li>
                  ))}
                </ul>

                <div className="flex items-center justify-between pl-14">
                  <span className="text-xs uppercase tracking-widest text-[#C8B8A6]">
                    {service.base_price_twd > 0
                      ? `NT$${service.base_price_twd.toLocaleString()}`
                      : t("tabifoto.services.from_price")}
                  </span>
                  <Link to="/booking"
                    className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t("tabifoto.hero.cta")}
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}